import { createAction } from "@redux/actions/actionCreators";

/**
 * Replace the full list of asset UUIDs for a given asset-typed field,
 * at either the product level (variantKey = null) or a specific variant.
 */
const [useSetProductAssetUuids, setProductAssetUuids] = createAction<{
  productUuid: string;
  variantKey: string | null;
  /** Identifier of the asset-typed field (e.g. "images"). */
  identifier: string;
  assetUuids: string[];
}>("product/setAssetUuids");

export default useSetProductAssetUuids;
export { setProductAssetUuids };
